export default __webpack_public_path__ + "static/media/assetsBalanceLogo.36c5ea5c.png";